import { render } from "./StockFilter.vue?vue&type=template&id=c94170f4&ts=true"
import script from "./StockFilter.vue?vue&type=script&lang=ts"
export * from "./StockFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__